import API from './API';
import { GET, POST } from '../utils/Executer';
import { QUALITY_METRICS_SERVICE_URL as servicePath } from '../constants/APIconstants';

class QualityMetricServiceAPI {
  getMyMetrics() {
    return API.client.execute(GET, `${servicePath}user`);
  }

  getQualityMetric({ id, withUserMetric = false }) {
    return API.client.execute(GET, `${servicePath}${id}?withUserMetric=${withUserMetric}`);
  }

  getOrganizationMetrics() {
    return API.client.execute(GET, `${servicePath}list`);
  }

  createQualityMetricRecords({ metricId, records }) {
    return API.client.execute(POST, `${servicePath}${metricId}/records`, records);
  }

  /**
   * Get cases for a specific quality metric
   * @param {{
   *  metricId: string,
   *  compliant: boolean | null,
   *  page: number
   * }} { metricId, compliant = null, page = 1 }
   * @return {{
   *  data: {
   *   cases: Array<{
   *     id: string,
   *     title: string,
   *     date: Date,
   *     compliant: boolean,
   *     reason: string | null
   *   }>,
   *   total: number,
   *   totalCompliant: number,
   *   hasMore: boolean
   *  }
   * }}
   * @memberof QualityMetricServiceAPI
   */
  getMetricCases({ metricId, compliant = null, page = 1 }) {
    const params = new URLSearchParams();

    if (compliant !== null) {
      params.append('compliant', compliant);
    }
    params.append('page', page);

    return API.client.execute(GET, `${servicePath}${metricId}/cases?${params.toString()}`);
  }

  /**
   * Get cases by case id and all its data
   * @param {{
   *  caseId: string,
   * }} { caseId: string }
   * @return {{
   *  data: {
   *   case: {
   *    externalId: string,
   *    date: date,
   *    participants: Array<{ id: string, firstName: string, lastName: string, email: string }>,
   *    metrics: Array<{ metricId: string, title: string, meetsGroupGoal: boolean, reason: string | null, metadata: object }>,
   *    metadata: object
   *   }
   *  }
   * }}
   * @memberof QualityMetricServiceAPI
   */
  getCasesById({ caseId }) {
    return API.client.execute(GET, `${servicePath}cases/${caseId}`);
  }
}

export default new QualityMetricServiceAPI();
